
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ORDERAPI } from '@/api/orders'
import { getuserCurrentApp, setRole } from '@/utils/cookies'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'DetailEvents'
})
export default class extends Vue {
  @Prop({ default: () => {
    return {}
  } }) private ticket!: any

  private activities = []
  private eventsLoading = false

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get currentTid () {
    return this.ticket.tid || this.$route.params.tid || 0
  }

  get currentTtype () {
    return this.ticket.ticket_type || this.$route.params.ticketType || 0
  }

  mounted() {
    this.$nextTick(() => {
      this.handleEvents()
    })
  }

  // 获取事件详情，也在父组件中详情更新后调用
  private handleEvents() {
    if (this.eventsLoading) return
    this.eventsLoading = true
    ORDERAPI.eventsTicket({
      tid: this.currentTid,
      ticket_type: this.currentTtype,
      app_id: this.userCurrentApp
    }).then((res: any) => {
      if (this.ticket.tid) {
        this.getActivities(res.data)
      } else {
        setTimeout(() => { // 当ticket未加载完时，异步
          this.getActivities(res.data)
        }, 200)
      }
      const userRole = String(res.data[0].role)
      setRole(userRole)
      UserModule.setUserRole(userRole)
    }).catch(() => {
      this.eventsLoading = false
    })
  }

  private getActivities(origActivities: any) {
    const restEvents = this.addEvents()
    this.activities = origActivities.concat(restEvents)
    this.eventsLoading = false
  }

  // 事件补充
  private addEvents() {
    let eventsItem = {
      action: '',
      action_time: '',
      describe: '',
      user: '',
      color: '#E4E7ED',
    }
    let restEvents = []
    switch (this.ticket.status) {
      case 1:
        restEvents.push(Object.assign({}, eventsItem, { action: '待受理' }), Object.assign({}, eventsItem, { action: '待完成' }))
        break
      case 2:
        restEvents.push(Object.assign({}, eventsItem, { action: '待完成' }))
        break
    }
    return restEvents
  }
}
